// General
import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';

// Translation

// Redux
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ViewListing.css';
import { Grid, Row } from 'react-bootstrap';
import cx from 'classnames';
import FontAwesome from 'react-icons/fa';

import { contactHostOpen } from '../../actions/message/contactHostModal';

// Components
import LocationMap from '../../components/ViewListing/LocationMap';
import Loader from '../../components/Loader';
import NotFound from '../notFound/NotFound';
import Details from '../presentation/Details/Details';
import { colors } from '../../tailwind';

// Graphql
import BlockedDatesQuery from './BlockedDates.graphql';
import ListingDataQuery from './getListingData.graphql';
import MoreReviewsQuery from './MoreReviews.graphql';
import SimilarListsQuery from './getSimilarListing.graphql';

// ES6 Imports

// Locale
import { buildPhotoPath, buildImageColumns } from '../../helpers/photoutils';
import { bookingProcess } from '../../actions/booking/bookingProcess';
import ContactHost from '../../components/ViewListing/ContactHost/ContactHost';
import { getp } from '../../helpers/getProp';

// Or Access Link,Element,etc as follows

const durationFn = function(deltaTop) {
  return deltaTop;
};

class ViewListing extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    listId: PropTypes.number,
    preview: PropTypes.bool,
    isAdmin: PropTypes.bool,
    account: PropTypes.shape({
      userId: PropTypes.string,
    }),
    ListingBlockedDates: PropTypes.shape({
      loading: PropTypes.bool,
      UserListing: PropTypes.shape({
        blockedDates: PropTypes.array,
      }),
    }),
    getListingData: PropTypes.shape({
      loading: PropTypes.bool,
      UserListing: PropTypes.object,
    }),
    lat: PropTypes.number,
    lng: PropTypes.number,
    similarListsData: PropTypes.shape({
      loading: PropTypes.bool,
      getSimilarListing: PropTypes.array,
    }),
  };

  static defaultProps = {
    getListingData: {
      loading: false,
      UserListing: {
        userId: null,
      },
    },
    ListingBlockedDates: {
      loading: true,
      UserListing: {
        blockedDates: [],
      },
    },
    account: {
      userId: null,
    },
    isAdmin: false,
  };

  showContact = () => {
    this.props.contactHostOpen(this.props.listId);
  };

  render() {
    const {
      listId,
      title,
      getListingData: { loading, UserListing },
      preview,
    } = this.props;
    const { listReviewsData } = this.props;
    const {
      account: { userId },
      isAdmin,
      endDate,
      startDate,
      units,
    } = this.props;
    const {
      similarListsData: { getSimilarListing },
    } = this.props;
    const isBrowser = typeof window !== 'undefined';
    const smallDevice = isBrowser
      ? window.matchMedia('(max-width: 640px)').matches
      : undefined;

    if (isBrowser && loading && !UserListing) {
      return <Loader type="text" />;
    }
    let isHost = false;
    if (UserListing) {
      if (userId && userId === UserListing.userId) {
        isHost = true;
      } else if (isAdmin) {
        isHost = true;
      }
    }
    if (preview && !isHost) {
      console.log('Not a host', preview, isHost, userId, UserListing ? UserListing.userId : 'no User Listing');
      return <NotFound title={title} />;
    }

    if (!loading && !UserListing) {
      console.log('No Listing', loading, UserListing);
      return <NotFound title={title} />;
    }

    const Map = () => <LocationMap data={UserListing} height={375} />;

    const imgs = buildImageColumns(UserListing.listPhotos);
    const user = {
      profile: {
        profileId: UserListing.user.profile.profileId,
        yearJoined: new Date(
          UserListing.user.profile.createdAt,
        ).toLocaleDateString(),
        displayName: UserListing.user.profile.displayName,
        picture: UserListing.user.profile.picture,
        firstName: UserListing.user.profile.firstName,
        location: UserListing.user.profile.location,
      },
      email: UserListing.user.email,
      id: UserListing.userId,
    };

    let initialValues = {
      listId: UserListing.id,
      hostId: user.id,
      hostEmail: user.email,
      user: user.profile.firstName,
    };

    return (
      <div
        className={s.root}
        style={{
          backgroundColor: colors.background,
          maxWidth: preview ? '900px' : null,
        }}
      >
        <ContactHost
          initialValues={initialValues}
          id={UserListing.id}
          userId={userId}
          city={user.profile.location}
          profileId={user.profile.profileId}
          picture={user.profile.picture}
          displayName={user.profile.firstName}
          blockedDates={[]}
          minNight={0}
          maxNight={15}
          maxDaysNotice={7}
        />
        <div className={'pr-12 ' + s.container}>
          <div className={s.pageContainer}>
            <Grid fluid className={cx(s.horizontalLineThrough)}>
              <Row className={'m-0 ' + cx(s.pageContent)}>
                {UserListing && (
                  <Details
                    title={UserListing.title}
                    description={UserListing.description}
                    images={imgs.images1}
                    rentalConditions={
                      UserListing.listingRules || [
                        {
                          description:
                            'There are currently no rental conditions.',
                        },
                      ]
                    }
                    price={UserListing.basePrice / 100}
                    focusedImage={imgs.cover}
                    reviews={
                      (listReviewsData.moreListReviews &&
                        listReviewsData.moreListReviews.map(x => ({
                          createdAt: new Date(x.createdAt).toLocaleDateString(),
                          reviewContent: x.reviewContent,
                          rating: x.rating,
                          authorData: {
                            firstName: x.authorData.firstName,
                            lastName: x.authorData.lastName,
                            // picture: buildPhotoPath('x_small', x.authorData.picture),
                            picture: '',
                          },
                        }))) ||
                      []
                    }
                    reviewsCount={UserListing.reviewsCount || '?'}
                    averageRating={
                      UserListing.reviewsStarRating / UserListing.reviewsCount
                    }
                    ownersItems={
                      (UserListing &&
                        UserListing.user.listings
                          .filter(x => x.id !== UserListing.id)
                          .map(x => {
                            return {
                              title: x.title,
                              price: x.basePrice,
                              location: `${x.city}, ${x.state}`,
                              coverPhoto: x.coverPhotoId,
                              reviewsCount: x.reviewsCount || 0,
                              reviewsStarRating: x.reviewsStarRating,
                              id: x.id,
                            };
                          })) ||
                      []
                    }
                    otherInterests={
                      (getSimilarListing &&
                        getSimilarListing.map(x => {
                          return {
                            title: x.title,
                            price: x.basePrice,
                            location: `${getp(x, 'listingAddresses.0.city')}, ${getp(
                              x,
                              'listingAddresses.0.state',
                            )}`,
                            coverPhoto: x.coverPhotoName,
                            reviewsCount: x.reviewsCount || 0,
                            reviewsStarRating: x.reviewsStarRating,
                            id: x.id,
                          };
                        })) ||
                      []
                    }
                    user={user}
                    location={
                      getp(UserListing, 'listingAddresses') &&
                      UserListing.listingAddresses
                        .map(a => a.city + ', ' + a.state)
                        .join(' / ')
                    }
                    Map={Map}
                    listId={this.props.listId}
                    startDate={startDate}
                    endDate={endDate}
                    units={units}
                    bookingProcess={this.props.bookingProcess}
                    preview={preview}
                    contactHostOpen={this.showContact}
                    blockedDates={UserListing.blockedDates}
                    isHost={isHost}
                    category={UserListing.category}
                  />
                )}
              </Row>
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

// Decorate with connect to read form values
const selector = formValueSelector('RequestForm');

const mapState = state => ({
  startDate: selector(state, 'startDate'),
  endDate: selector(state, 'endDate'),
  units: selector(state, 'units'),
  account: state.account.data,
  isAdmin: state.runtime.isAdminAuthenticated,
});

const mapDispatch = {
  bookingProcess,
  contactHostOpen,
};

export default compose(
  withStyles(s),
  connect(
    mapState,
    mapDispatch,
  ),
  graphql(ListingDataQuery, {
    name: 'getListingData',
    options: props => {
      return {
        variables: {
          listId: props.listId,
          preview: props.preview,
        },
        fetchPolicy: 'network-only',
        ssr: true,
      };
    },
  }),
  graphql(MoreReviewsQuery, {
    name: 'listReviewsData',
    options: props => ({
      variables: {
        listId: props.listId,
      },
      fetchPolicy: 'network-only',
      ssr: false,
    }),
  }),
  graphql(SimilarListsQuery, {
    name: 'similarListsData',
    options: props => ({
      variables: {
        listId: props.listId,
        lat: props.lat,
        lng: props.lng,
      },
      fetchPolicy: 'network-only',
      ssr: false,
    }),
  }),
)(ViewListing);



// WEBPACK FOOTER //
// ./src/routes/viewListing/ViewListing.js